// 组串路由
import seriesLayout from '@/layout/index.vue'
import seriesHome from '@/views/series/home.vue'
import seriesAlarm from '@/views/series/alarm.vue'
import seriesHistory from '@/views/series/history.vue'
import seriesStation from '@/views/series/station.vue'
import seriesCollector from '@/views/series/collector.vue'
import seriesReal from '@/views/series/real.vue'
import seriesReport from '@/views/series/report.vue'
import seriesLink from '@/views/series/link.vue'
import seriesDevlist from '@/views/series/devlist.vue'

const router = {
  path: '/layout',
  name: 'seriesLayout',
  component: seriesLayout,
  redirect: '/home',
  children: [
    // 概况
    {
      path: '/series/home',
      name: 'series_home',
      meta: {
        showTab: false,
        name: 'series_home mulshow',
        title: '组串 概况'
      },
      component: seriesHome
    },
    // 报警列表
    {
      path: '/series/alarm',
      name: 'series_alarm',
      meta: {
        showTab: false,
        name: 'series_alarm mulshow',
        title: '组串 报警列表'
      },
      component: seriesAlarm
    },
    // 历史数据
    {
      path: '/series/history',
      name: 'series_history',
      meta: {
        showTab: false,
        name: 'series_history mulshow',
        title: '组串 历史数据'
      },
      component: seriesHistory
    },
    // 电站设置
    {
      path: '/series/station',
      name: 'series_station',
      meta: {
        showTab: false,
        name: 'series_station mulshow',
        title: '组串 电站设置'
      },
      component: seriesStation
    },
    // 采集器列表
    {
      path: '/series/collector',
      name: 'series_collector',
      meta: {
        showTab: false,
        name: 'series_collector mulshow',
        title: '组串 采集器列表'
      },
      component: seriesCollector
    },
    // 实时数据
    {
      path: '/series/real',
      name: 'series_real',
      meta: {
        showTab: false,
        name: 'series_real mulshow',
        title: '组串 实时数据'
      },
      component: seriesReal
    },
    // 报表下载
    {
      path: '/series/report',
      name: 'series_report',
      meta: {
        showTab: false,
        name: 'series_report mulshow',
        title: '组串 报表下载'
      },
      component: seriesReport
    },
    // 打开大屏
    {
      path: '/series/link',
      name: 'series_link',
      meta: {
        showTab: true,
        name: 'series_link mulshow',
        title: '组串 打开大屏'
      },
      component: seriesLink
    },
    // 设备列表
    {
      path: '/series/devlist',
      name: 'series_devlist',
      meta: {
        showTab: true,
        name: 'series_devlist mulshow',
        title: '组串 设备列表'
      },
      component: seriesDevlist
    }
  ]

}

export default router
